// extracted by mini-css-extract-plugin
module.exports = {"Gallery":"Gallery_Gallery__2tzqO","ImageBox":"Gallery_ImageBox__QUzjr","Image":"Gallery_Image__29cM6"};